import { ActionType, createAction } from 'typesafe-actions'
import { Person } from 'scenes/Dashboard/data/people/types'

export const getFilteredPeople = createAction('/scenes/Dashboard/scenes/PeopleManager/GET_FILTERED_PEOPLE')

export const updateCurrentPage = createAction(
  '/scenes/Dashboard/scenes/PeopleManager/CHANGE_CURRENT_PAGE',
  (resolve) => (nextPage: number) => resolve({ nextPage })
)

export const updateSearch = createAction(
  '/scenes/Dashboard/scenes/PeopleManager/UPDATE_SEARCH_QUERY',
  (resolve) => (search: string) => resolve({ search })
)

export const resetSearch = createAction('/scenes/Dashboard/scenes/PeopleManager/RESET_SEARCH')

export const openNewPersonForm = createAction('/scenes/Dashboard/scenes/PeopleManager/OPEN_NEW_PERSON_FORM')

export const openPersonForm = createAction(
  '/scenes/Dashboard/scenes/PeopleManager/OPEN_PERSON_FORM',
  (resolve) => (personId: number) => resolve({ personId })
)

export const closePersonForm = createAction('/scenes/Dashboard/scenes/PeopleManager/CLOSE_PERSON_FORM')

export const selectPerson = createAction(
  '/scenes/Dashboard/scenes/PeopleManager/SELECT_PERSON',
  (resolve) => (personId: number) => resolve({ personId })
)

export const updatePerson = createAction(
  '/scenes/Dashboard/scenes/PeopleManager/UPDATE_PERSON',
  (resolve) => (person: Person) => resolve({ person })
)

export const createPerson = createAction(
  '/scenes/Dashboard/scenes/PeopleManager/NEW_PERSON',
  (resolve) => (person: Person) => resolve({ person })
)

export type PeopleManagerAction = ActionType<
  | typeof getFilteredPeople
  | typeof updateCurrentPage
  | typeof updateSearch
  | typeof resetSearch
  | typeof openNewPersonForm
  | typeof closePersonForm
  | typeof openPersonForm
  | typeof updatePerson
  | typeof createPerson
  | typeof selectPerson
>
